export default __webpack_public_path__ + "static/media/empireToken.9ba2e484.svg";